export default {
  props: {
    title: {
      type: String,
      default: '开奖结果-重庆时时彩'
    },
    data: {
      type: Object,
      default() {
        return {
          head: [],
          body: []
        }
      }
    },
  },
  computed: {
    head() {
      return this.data.head || [];
    },
    body() {
      return this.data.body || [];
    }
  },
  methods: {
    show() {
      this.$refs.wrap.show();
    },
    hide() {
      this.$refs.wrap.hide();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dialog/mixin.js